import { Component, inject } from '@angular/core';
import { LayoutService } from '../../service/layout.service';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { DividerModule } from 'primeng/divider';

@Component({
  selector: '[app-rightmenu]',
  standalone: true,
    imports: [DrawerModule, DividerModule, SelectModule, InputTextModule, FormsModule, ButtonModule],
  templateUrl: './rightmenu.component.html',
  styleUrl: './rightmenu.component.css'
})
export class RightmenuComponent {
  layoutService: LayoutService = inject(LayoutService);

  cards = [
      { label: '*****24', value: { id: 1, name: '*****24', code: 'A1' } },
      { label: '*****75', value: { id: 2, name: '*****75', code: 'A2' } }
  ];

  selectedCard: any;
  amountValue: string = '';

  get rightMenuVisible(): boolean {
      return this.layoutService.layoutState().rightMenuVisible;
  }

  set rightMenuVisible(_val: boolean) {
      this.layoutService.layoutState.update((prev) => ({ ...prev, rightMenuVisible: _val }));
  }
}
